<app-data-grid
  [dataItems]="changesets"
  [columns]="columns"
  [fontSize]="fontSize"
  [state]="state"
  [filterable]="'menu'"
  (dataStateChange)="onDataStateChanged($event)"
>
  <ng-template #toolbarTemplate>
    <div class="k-toolbar k-grid-toolbar">
      <h4 class="m-0">Changeset type</h4>
      &nbsp;
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="types"
          [(ngModel)]="selectedType"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        ></kendo-dropdownlist>
      </div>
    </div>
  </ng-template>
</app-data-grid>
